import { useTypedSelector } from '../../../../../hooks/useTypedSelector';
import { studiesSelector } from '../../redux/studies.reducer';
import { StudyCreationGuideWrapper } from './components';
import './studyCreationGuide.scss';

export const StudyCreationGuide: React.FC = () => {
  const { currentStep } = useTypedSelector(studiesSelector);
  const JSX = currentStep.component;
  return (
    <StudyCreationGuideWrapper hasCustomButtons={currentStep.hasCustomButtons}>
      <JSX />
    </StudyCreationGuideWrapper>
  );
};
